import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import BreadCrumb from './BreadCrumb';
import { getLinksFromPath } from './getLinksFromPath';

export const collectBreadcrumbParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof BreadCrumb> | undefined => {
  if (!page.showBreadcrumbs) {
    return undefined;
  }
  const links = getLinksFromPath(page.path);

  return {
    component: ReactComponentType.Breadcrumb,
    props: {
      links: links,
    },
  };
};
